import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'

interface CustomHoursTemplateProps extends WithStyles<typeof styles> {
	required?: boolean
	hours?: number
	label: string
	prop: string
	onHoursChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  serviceType?: string
}

const CustomHoursTemplate: React.FC<CustomHoursTemplateProps> = (props: CustomHoursTemplateProps) => {
	const { classes, hours, label, onHoursChange, prop, required } = props

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				{label}&#58; { props.serviceType === 'CAREER_EXPLORATION_ESSENTIAL_SKILLS' && (<span className={classes.requiredField} >*</span> ) }
			</Grid>
			<Grid item={true} xs={6} sm={4}>
				<TextField
					name={prop}
					required={required}
					className={classes.dropdown}
					value={hours || ''}
					onChange={onHoursChange}
					margin="dense"
					variant="outlined"
					InputProps={{
						inputProps: {
							type: 'number',
							min: '0',
							step: '0.25',
						},
					}}
				/>
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(CustomHoursTemplate)
